<template>
  <div class="lotti-session-container">

    <div class="lotti-grid-row lotti-grid-row-mid">

      <div class="lotti-grid-col lotti-grid-col-66">

        <div class="lotti-module">

          <div class="lotti-module-title">{{ sessionTitle }}</div>

          <el-form :model="sessionForm" :rules="sessionRules" label-width="110px" ref="sessionForm" class="lotti-module-form">

            <div class="lotti-form-separator-50">

              <el-form-item label="Datum" prop="date">
                <el-date-picker
                    v-model="sessionForm.date"
                    :picker-options="{ firstDayOfWeek: 1}"
                    type="date"
                    format="dd.MM.yyyy"
                    placeholder="Datum wählen">
                </el-date-picker>
              </el-form-item>

              <!-- postgresql integer	4 bytes	-2147483648 to +2147483647-->
              <el-form-item label="Dauer (min)" prop="duration">
                <el-input-number
                    v-model="sessionForm.duration"
                    :max="2147483647"
                    :min="1">
                </el-input-number>
              </el-form-item>

              <el-form-item label="Therapeutin" prop="therapistId">
                <el-select
                    clearable
                    filterable
                    v-model="sessionForm.therapistId"
                    placeholder="Therapeutin wählen">
                  <el-option
                      v-for="item in therapistOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Therapiekind" prop="childId">
                <el-select
                    :disabled="isStatusDisabled()"
                    filterable
                    clearable
                    v-model="sessionForm.childId"
                    placeholder="Therapiekind wählen">
                  <el-option
                      v-for="item in childOptions"
                      :disabled="item.isArchived"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

            </div>

            <div class="lotti-form-separator-50">

              <el-form-item label="Kategorie" prop="category">
                <el-select
                    v-model="sessionForm.category"
                    filterable
                    clearable
                    placeholder="Kategorie wählen">
                  <el-option-group
                      v-for="group in categoryOptions"
                      :key="group.label"
                      :label="group.label">
                    <el-option
                        v-for="item in group.options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                  </el-option-group>
                </el-select>
              </el-form-item>

              <el-form-item label="Status" prop="status">
                <el-select
                    :disabled="isStatusDisabled()"
                    v-model="sessionForm.status"
                    filterable
                    clearable
                    placeholder="Status wählen">
                  <el-option
                      v-for="item in statusOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="Beschreibung" prop="text">
                <el-input
                    type="textarea"
                    maxlength="200"
                    resize="none"
                    show-word-limit
                    placeholder="Text eingeben"
                    v-model="sessionForm.text">
                </el-input>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="submitData()">Speichern</el-button>
                <el-button type="primary" @click="submitData(true)" v-if="!$route.params.goBackOneHistoryStep">Speichern + neu</el-button>
                <el-button type="secondary" @click="$route.params.goBackOneHistoryStep ? $router.go(-1) : $router.push('/')">Zurück</el-button>
              </el-form-item>

            </div>

          </el-form>

        </div>
      </div>

    </div>

  </div>
</template>


<script>
import Vue from '../../main.js';
import auth from '../../auth.js';
import sessionHelper from '../../Helpers/SessionHelper';
import datePickerHelper from '../../Helpers/DatePickerHelper.js';
import validation from '../../Helpers/ValidationHelper';
import notification from '../../Helpers/NotificationHelper';


export default {

  data() {
    return {

      auth: auth,
      errorAlert: null,
      sessionHelper: sessionHelper,
      datePickerHelper: datePickerHelper,

      sessionTitle: 'Neuer Zeiteintrag',
      newSessionAfterSubmit: false,

      sessionForm: {
        id: null,
        date: null,
        duration: null,
        category: null,
        status: null,
        text: null,
        therapistId: null,
        childId: null,
      },

      therapistOptions: [],
      childOptions: [],
      statusOptions: sessionHelper.getStatusTypesList(),
      categoryOptions: sessionHelper.getAllCategoryTypes(),

      sessionRules: {
        date: [
          validation.getRequiredValidationObject('change')
        ],
        duration: [
          validation.getRequiredValidationObject('change')
        ],
        therapistId: [
          validation.getRequiredValidationObject('change'),
        ],
        childId: [
          //validation.getRequiredValidationObject('change'),
        ],
        category: [
          validation.getRequiredValidationObject('change'),
        ],
        status: [
          //validation.getRequiredValidationObject('change'),
        ],
        text: [
          validation.getMinMaxValidationObject(0, 200, 'change'),
        ],
      },
    }
  },

  methods: {

    isStatusDisabled() {
      //if category is NOT billable, disable the status input
      return this.sessionForm.category ? !this.sessionForm.category.startsWith('b') : false;
    },

    updateTitle() {
      this.sessionTitle = "Zeiteintrag vom " + this.datePickerHelper.formatUTCDateCH(this.sessionForm.date) + " à " + this.sessionForm.duration + " min";
    },

    submitData(newSessionAfterSubmit = false) {

      this.$refs['sessionForm'].validate((valid) => {

        if (valid) {

          //correctly format start and end date BUGFIX special treatment for datetime (no problem with date, because postgres will cut time for DATE
          //type in DB, but not for DATETIME. So js new Date() is adding GMT +1 on each load. when we update the data we add repellingly +1h
          let date = new Date(this.sessionForm.date);
          let dateStart = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0);
          let dateEnd = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, this.sessionForm.duration, 0);

          Vue.http.post(
              //update or create? decide based on id field
              this.sessionForm.id ? 'api/v1/session/update' : 'api/v1/session/create',
              {
                id: this.sessionForm.id,
                datetime_start: this.datePickerHelper.formatUTCDateTimeUS(dateStart),
                datetime_end: this.datePickerHelper.formatUTCDateTimeUS(dateEnd),
                category: this.sessionForm.category,
                status: this.isStatusDisabled() || this.sessionForm.status === '' ? null : this.sessionForm.status,
                text: this.sessionForm.text,
                therapist_id: this.sessionForm.therapistId,
                child_id: this.isStatusDisabled() || !this.sessionForm.childId ? null : this.sessionForm.childId
              }
          ).then(response => {

            if(newSessionAfterSubmit) {

              //instead of pushing to route session/0 and force update (not proper)
              //we reset the sessionForm and all is fine
              this.resetSessionFormToDefaultValue();

              //set new title
              this.sessionTitle = 'Neuer Zeiteintrag';

              //update router url to new session url
              this.$router.push('/session/0').catch(()=>{})


            } else {

              //set id from sucesse response
              this.sessionForm.id = response.data.id;

              //set new title
              this.updateTitle();

              //update the url via router push
              if (Number(this.$route.params.sessionId) !== this.sessionForm.id) {
                this.$router.push('/session/' + this.sessionForm.id)
              }
            }
            //show success msg
            notification.showSuccess(this, 'Daten wurden erfolgreich gespeichert');

          }, error => {
            notification.showError(this, 'Daten konnten nicht gespeichert werden');
          })
        }
      })
    },

    getSessionData() {
      Vue.http.get(
          'api/v1/session/get-by-id',
          {
            params: {
              id: this.sessionForm.id,
            }
          }
      ).then(response => {

        //set additionally date and duration
        let d1 = new Date(response.data.datetimeStart);
        let d2 = new Date(response.data.datetimeEnd);
        this.sessionForm.duration = Math.floor((d2 - d1) / (1000*60));//calc duration in minutes
        this.sessionForm.date = d1;

        //replace all session data
        this.sessionForm.id = response.data.id;
        this.sessionForm.category = response.data.category;
        this.sessionForm.status = response.data.status;
        this.sessionForm.text = response.data.text;
        this.sessionForm.therapistId = response.data.therapistId;
        this.sessionForm.childId = response.data.childId;

        //set new title
        this.updateTitle();

      }, error => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    resetSessionFormToDefaultValue() {
      this.sessionForm = {
        id: null,
        date: new Date(),//default today
        duration: 45,//default min
        category: 'b_th',//default 'berechenbar therapie'
        status: null,
        text: null,
        therapistId: auth.user.profile.id,//default self
        childId: null,
      }
    },

    getAllMyReducedChildren() {
      Vue.http.get(
          'api/v1/child/get-all-my-reduced'
      ).then(response => {
        if(response.data) {
          this.childOptions = response.data.map(item => {
            return { value: item.id, label: item.name, isArchived: item.isArchived };
          })
        }
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },

    getAllTherapists() {
      Vue.http.get(
          'api/v1/therapist/get-all'
      ).then(response => {
        this.therapistOptions = response.data.map(item => {
          return { value: item.id, label: item.name };
        });
      }, response => {
        //notification.showError(this, 'Daten konnten nicht geladen werden');
      })
    },
  },

  beforeMount() {

    //reset session form to default value
    this.resetSessionFormToDefaultValue()

    // take session id as number > 0, else null
    this.sessionForm.id = Number(this.$route.params.sessionId) || null;

    //get session data, if sessionId is set
    if(this.sessionForm.id !== null) {
      this.getSessionData();
    }
    //get all children assigned to the current therapist/user (+NOT in status "final" or "pause")
    this.getAllMyReducedChildren();

    //get all therapists of service if user is lead_therapist, else only user itself
    this.getAllTherapists();
  },
}

</script>